import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

const Slider = React.forwardRef(({ className, onValueChange, onPointerDown, ...props }, ref) => {
  // Track the last focused thumb so we can re-focus it after Radix re-renders
  // (Radix can briefly drop focus to <body> during the re-render that follows
  // an onValueChange, which lets deck-level arrow keys steal subsequent keystrokes.)
  const lastThumbRef = React.useRef(null)
  const bump = () => {
    if (typeof window !== "undefined" && typeof window.__deckInteractionLock === "function") {
      window.__deckInteractionLock()
    }
  }
  const handleChange = (v) => {
    bump()
    onValueChange?.(v)
    // After Radix processes the value change, restore focus to the thumb
    if (lastThumbRef.current) {
      requestAnimationFrame(() => {
        if (lastThumbRef.current && document.activeElement === document.body) {
          try { lastThumbRef.current.focus() } catch {}
        }
      })
    }
  }
  return (
    <SliderPrimitive.Root
      ref={ref}
      className={cn("relative flex w-full touch-none select-none items-center", className)}
      {...props}
      onValueChange={handleChange}
      onPointerDown={(e) => { bump(); onPointerDown?.(e); }}
      onFocusCapture={(e) => {
        bump()
        if (e.target?.getAttribute?.("role") === "slider") {
          lastThumbRef.current = e.target
        }
      }}>
      <SliderPrimitive.Track
        className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-primary/20">
        <SliderPrimitive.Range className="absolute h-full bg-primary" />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        className="block h-4 w-4 rounded-full border border-primary/50 bg-background shadow transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50" />
    </SliderPrimitive.Root>
  )
})
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
